module.exports = __webpack_public_path__ + "img/campana-login.1d89cead.png";